import React from "react";

class Movie extends React.Component {
  render() {
    return (
      <React.Fragment>
        {this.props.overview && (
          <div className="rounded cursor-default border-b-2 shadow p-4 mb-4">
            <div className="font-bold mb-2">Overview</div>
            <p className="text-grey-dark text-grey-darker tracking-normal text-justify text-base whitespace-pre-line">
              {this.props.overview}
            </p>
          </div>
        )}
      </React.Fragment>
    );
  }
}

export default Movie;



// WEBPACK FOOTER //
// ./src/components/Media/Movie.js